module.exports = __webpack_public_path__ + "static/media/invite.db7971b9.svg";